/**
 * App base path, always normalized to end with a single trailing slash.
 *
 * Vite's BASE_URL is meant to end with a slash, but some envs set VITE_BASE_URL
 * without one (prod/playground use `/`, previews use `/mobile`). Concatenating
 * `${BASE_URL}login` then yields `/mobilelogin`. Use this so joins always
 * produce a single slash: `/` → `/`, `/mobile` → `/mobile/`.
 */
export const basePath = import.meta.env.BASE_URL.endsWith('/')
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;
